import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { LocationEmptyState } from 'components/location-empty-state';
import { useEnableNativeTabBarExperiment } from 'experiments/use-enable-native-tab-bar-experiment';
import LoyaltyInRestaurantRedemption from 'pages/loyalty/loyalty-in-restaurant-redemption/loyalty-in-restaurant-redemption';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

export default function MyCodeRoute() {
  const { noStoreSelected } = useStoreRequired(true, undefined, routes.myCode);
  // The native (Liquid Glass) tab bar has no header slot like the classic `Tabs`
  // screenOptions.header does, so this screen must render its own header when treatment is active.
  const { isTreatment: isNativeTabBarEnabled } = useEnableNativeTabBarExperiment();

  const content = noStoreSelected ? (
    <LocationEmptyState title={t('emptyMyCodeHeading')} message={t('emptyMenuMessage')} />
  ) : (
    <LoyaltyInRestaurantRedemption />
  );

  if (isNativeTabBarEnabled) {
    return (
      <>
        <StandardMobileHeader />
        {content}
      </>
    );
  }

  return content;
}
